import { z } from 'zod';

export const ERROR_CODES = [
  'bad_request',
  'validation_failed',
  'unauthenticated',
  'forbidden',
  'not_found',
  'conflict',
  'version_conflict',
  'unprocessable',
  'rate_limited',
  'internal',
  /** The resource existed but is no longer usable (an expired or used undo token). */
  'gone',
] as const;
export const ErrorCode = z.enum(ERROR_CODES);
export type ErrorCode = z.infer<typeof ErrorCode>;

/** Every non-2xx API response has this body. */
export const ApiErrorBody = z.object({
  error: z.object({
    code: ErrorCode,
    message: z.string(),
    details: z.unknown().optional(),
    requestId: z.string().optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBody>;

export const HTTP_STATUS_BY_CODE: Record<ErrorCode, number> = {
  bad_request: 400,
  validation_failed: 400,
  unauthenticated: 401,
  forbidden: 403,
  not_found: 404,
  conflict: 409,
  version_conflict: 409,
  unprocessable: 422,
  rate_limited: 429,
  internal: 500,
  gone: 410,
};

/** Validation issue detail entry in `error.details` for `validation_failed`. */
export type ValidationIssue = { path: string; message: string };

export type Paginated<T> = { items: T[]; nextCursor: string | null };

export const API_PREFIX = '/api/v1';
